import React, { useState, useEffect } from 'react';
import Icon from 'components/shared/searchIcon';
import SuggestionsListComponent from '../suggestionsList';
import styles from './searchBar.module.scss';

const SearchBar = ({
  viewport,
  searchText,
  activeFilters,
  disableSearch,
  userCountryCode,
  showSuggestions,
  initialViewport,
  selectedSuggestion,
  handleSearchClick,
  handleEnterKeyPress,
  setViewport,
  setSearchText,
  setDisableSearch,
  setShowSuggestions,
  searchBarPlaceholder,
  setSelectedSuggestion,
}) => {
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);

  const onClick = async e => {
    setSelectedSuggestion(true);
    setSearchText(e.target.innerText);

    setFilteredSuggestions([]);
    setActiveSuggestionIndex(0);
    setShowSuggestions(false);
    handleSearchClick(e.target.innerText);
  };

  const onChange = async userInput => {
    const cleanedInput = userInput
      ? userInput?.replace('&', 'and')?.replace(/[^a-zA-Z0-9 ]/g, '')
      : '';
    const response = await fetch(
      `/api/get-predictions?input=${cleanedInput}&country=${userCountryCode}`
    );
    const { data } = await response.json();

    if (userInput === '' && activeFilters === 'AMBASSADOR SALONS') {
      setViewport({
        ...viewport,
        latitude: initialViewport.latitude,
        longitude: initialViewport.longitude,
        zoom: 12,
      });
  
    } else if (userInput === '' && activeFilters === 'ALL SALONS') {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
      setActiveSuggestionIndex(0);

      setViewport({
        ...viewport,
        latitude: initialViewport.latitude,
        longitude: initialViewport.longitude,
        zoom: 12,
      });
    } else if (selectedSuggestion) {
      setShowSuggestions(false);
    } else {
      setFilteredSuggestions(data);
      setShowSuggestions(true);
      setActiveSuggestionIndex(0);
    }
  };

  useEffect(() => {
    if (!disableSearch) {
      const delayDebounceFn = setTimeout(() => {
        setSelectedSuggestion(false);
        onChange(searchText);
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchText]);

  const handleBlur = () => {
    setTimeout(() => {
      setShowSuggestions(false);
    }, 100);
  };

  // show suggestions on focus
  const handleFocus = () => {
    if (searchText && filteredSuggestions.length > 0) {
      setShowSuggestions(true);
    }
  };

  return (
    <div className={styles.searchForm}>
      <div className={styles.searchBox}>
        <input
          className={styles.input}
          type="text"
          placeholder={searchBarPlaceholder}
          value={searchText}
          onChange={e => {
            setSearchText(e.currentTarget.value);
            setDisableSearch(false);
          }}
          onKeyPress={handleEnterKeyPress}
          onBlur={handleBlur}
          onClick={handleFocus}
        />
        <Icon className={styles.icon} onClick={() => handleSearchClick(searchText)} />
      </div>
      {showSuggestions && searchText && (
        <SuggestionsListComponent
          filteredSuggestions={filteredSuggestions}
          activeSuggestionIndex={activeSuggestionIndex}
          onClick={onClick}
        />
      )}
    </div>
  );
};
export default SearchBar;
